@if (showLoader && hasData) {
    <ms-component-loader />
}

@if (hasData && banner && (hideGamingCrossSellByArc$ | async) === false) {
    @if (ofType(banner, 'CasinoLink')) {
        <ms-casino-banner-link [model]="banner" [position]="position" (bannerDataLoaded)="bannerDataLoaded($event)" />
    } @else if (ofType(banner, 'SportLink')) {
        <ms-sport-banner-link [model]="banner" [position]="position" (bannerDataLoaded)="bannerDataLoaded($event)" />
    } @else if (ofType(banner, 'Jackpot')) {
        <ms-banner-jackpot [model]="banner" [position]="position" (bannerDataLoaded)="bannerDataLoaded($event)" />
    } @else if (ofType(banner, 'Games')) {
        <ms-banner-games [model]="banner" [position]="position" (bannerDataLoaded)="bannerDataLoaded($event)" />
    } @else if (ofType(banner, 'Vyml')) {
        <ms-vyml [model]="banner" [position]="position" (bannerDataLoaded)="bannerDataLoaded($event)" />
    } @else if (ofType(banner, 'Esport')) {
        <ms-banner-esport [model]="banner" (bannerDataLoaded)="bannerDataLoaded($event)" />
    }
}
